import DeleteAccountLink from "./DeleteAccountLink";

export default DeleteAccountLink;
